import {
  Card,
  CardMedia,
  CardContent,
  IconButton,
  Typography,
  Stack,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useContext } from "react";
import { UserContext } from "../context/UserContext";

// CartCard component represents an individual item in the shopping cart
const CartCard = ({ product }) => {
  const { dispatch } = useContext(UserContext); // Access the dispatch function from UserContext

  // Handles decreasing product quantity, removes product if amount is 1
  const handleDecrease = () => {
    if (product.amount > 1) {
      dispatch({ type: "decreaseAmount", payload: product });
    } else {
      dispatch({ type: "removeFromCart", payload: product });
    }
  };

  return (
    <Card
      sx={{
        display: "flex", // Uses flexbox for layout
        alignItems: "center", // Centers items vertically
        mb: 2, // Adds bottom margin
        paddingX: "15px", // Horizontal padding
        paddingY: { xs: "10px", sm: "0" }, // Responsive vertical padding
        flexDirection: { xs: "column", sm: "row" }, // Stack elements vertically on small screens
      }}
    >
      {/* Displays the product image */}
      <CardMedia
        component="img"
        image={product.images[0]} // Displays the first image from the product's images array
        alt="Product Image"
        sx={{
          width: { xs: "90px", sm: "100px" }, // Responsive width
          height: { xs: "90px", sm: "100px" }, // Responsive height
          borderRadius: 2, // Adds rounded corners
        }}
      />

      {/* Contains product details */}
      <CardContent
        sx={{
          width: "100%", // Ensures it takes full width
          display: "flex",
          justifyContent: "space-between", // Spreads content evenly
        }}
      >
        <Stack
          sx={{
            display: { xs: "flex", sm: "block" }, // Responsive display behavior
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          {/* Product title */}
          <Typography variant="subtitle1">{product.title}</Typography>
          {/* Product price */}
          <Typography variant="body2" color="text.secondary">
            ${product.price}
          </Typography>
          {/* Product quantity */}
          <Typography variant="body2" color="text.secondary">
            Quantity: {product.amount}
          </Typography>
          {/* Subtotal (price * quantity) */}
          <Typography variant="body2" color="text.secondary">
            Subtotal: ${product.amount * product.price}
          </Typography>
        </Stack>
      </CardContent>

      {/* Stack of action buttons for cart operations */}
      <Stack
        sx={{
          display: "flex",
          flexDirection: { xs: "row", sm: "column" }, // Buttons are in a row on small screens, column on larger screens
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Increase quantity button */}
        <IconButton
          sx={{ order: { xs: 3, sm: 1 } }} // Controls button order in different screen sizes
          onClick={() => dispatch({ type: "increaseAmount", payload: product })}
        >
          <AddIcon fontSize="small" sx={{ color: "white" }} />
        </IconButton>

        {/* Remove product from cart button */}
        <IconButton
          color="error"
          sx={{ order: { xs: 2, sm: 2 } }}
          onClick={() => dispatch({ type: "removeFromCart", payload: product })}
        >
          <HighlightOffIcon fontSize="small" />
        </IconButton>

        {/* Decrease quantity button */}
        <IconButton sx={{ order: { xs: 1, sm: 3 } }} onClick={handleDecrease}>
          <RemoveIcon fontSize="small" sx={{ color: "white" }} />
        </IconButton>
      </Stack>
    </Card>
  );
};

export default CartCard;
